import {
  useCurrentUserQuery,
  useOrganizationExistsQuery,
  useUserFirstOrganizationQuery,
} from '@app/graphql';
import { getLastVisitedOrgsCache } from '@hopin-team/dashboard-constants';
import { generateOrganizationSlug } from '@hopin-team/dashboard-shared';
import { useTranslation } from '@hopin-team/provider-translation';
import { Loading } from '@hopin-team/ui-loading';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const PostLoginRedirect = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [{ data: currentUserData, fetching: currentUserFetching }] =
    useCurrentUserQuery();

  const userId = currentUserData?.me?.id || '';
  const lastVisitedOrgIdForAllUsers = getLastVisitedOrgsCache();
  const lastVisitedOrgId = userId ? lastVisitedOrgIdForAllUsers[userId] : null;

  const [{ data: lastVisitedOrgData, fetching: lastVisitedOrgFetching }] =
    useOrganizationExistsQuery({
      variables: {
        organizationId: lastVisitedOrgId || '',
      },
      pause: !lastVisitedOrgId,
    });

  const [{ data: userFirstOrgData, fetching: userFirstOrgFetching }] =
    useUserFirstOrganizationQuery();

  useEffect(() => {
    if (currentUserFetching || userFirstOrgFetching || lastVisitedOrgFetching)
      return;

    if (lastVisitedOrgData?.organization) {
      navigate(
        `org/${generateOrganizationSlug(
          lastVisitedOrgData.organization.id,
          lastVisitedOrgData.organization.name,
        )}`,
      );
      return;
    }

    const firstOrg = userFirstOrgData?.me?.organizations?.edges?.[0]?.node;
    if (firstOrg) {
      navigate(`org/${generateOrganizationSlug(firstOrg.id, firstOrg.name)}`);
      return;
    }

    navigate('/attendee');
  }, [
    currentUserFetching,
    lastVisitedOrgId,
    lastVisitedOrgFetching,
    lastVisitedOrgData,
    userFirstOrgFetching,
    userFirstOrgData,
    navigate,
  ]);

  return <Loading text={t('loading')} poweredByText={t('poweredBy')} />;
};
